<template>
  <div id="fd-zjxx">
    <my-title the-title="证据信息" />
      <van-cell-group class="fd-com-scroll">
        <van-field
          v-model="formData.nZjlxTxt"
          class="special-readonly"
          required
          clearable
          readonly
          label="证据类型"
          right-icon="arrow"
          placeholder="请选择证据类型"
          @click="showZjbqsx = true"
        ></van-field>
        <van-popup v-model="showZjbqsx" position="bottom">
          <van-picker
            show-toolbar
            :columns="codeZjList"
            :default-index="0"
            @cancel="showZjbqsx = false"
            @confirm="onSxsmConfirm"
          ></van-picker>
        </van-popup>
        <van-field
          v-model.lazy.trim="formData.czjmc"
          required
          label="证据名称"
          placeholder="请输入证据名称"
        />
        <van-field required readonly label="原件原物">
          <van-radio-group v-model="formData.nyjwj" slot="input">
            <van-radio name="1">
              是
            </van-radio>
            <van-radio name="2">
              否
            </van-radio>
          </van-radio-group>
        </van-field>
        <van-field
          v-model.lazy.trim="formData.czjly"
          required
          label="证据来源"
          placeholder="证据来源"
        />
        <!--保全开始日期-->
        <van-field
          v-model="formData.dBqksrq"
          class="special-readonly"
          required
          clearable
          readonly
          label="保全开始日期"
          right-icon="arrow"
          placeholder="请选择保全开始日期"
          @click="showBqksrq = true"
        ></van-field>
        <van-popup v-model="showBqksrq" position="bottom">
          <van-datetime-picker
            v-model="bqksrqCurrentDate"
            type="date"
            @confirm="onBqrqConfirm('1')"
            @cancel="onBqrqcancelFn('1')"
          />
        </van-popup>
        <!-- 保全结束日期-->
        <van-field
          v-model="formData.dBqjsrq"
          class="special-readonly"
          required
          clearable
          readonly
          label="保全结束日期"
          right-icon="arrow"
          placeholder="请选择保全结束日期"
          @click="showBqjsrq = true"
        ></van-field>
        <van-popup v-model="showBqjsrq" position="bottom">
          <van-datetime-picker
            v-model="bqjsrqCurrentDate"
            type="date"
            @confirm="onBqrqConfirm('2')"
            @cancel="onBqrqcancelFn('2')"
          />
        </van-popup>
        <van-field
          class="fd-textarea"
          type="textarea"
          rows="2"
          show-word-limit
          autosize
          :rules="[{ required: true, message: '请输入证据说明' }]"
          v-model="formData.cSm"
          label="证据说明"
          maxlength="200"
          placeholder="请输入证据说明"
        />
      </van-cell-group>
      <div class="fd-com-btn-container">
        <van-button
          v-if="formData.zjxxId"
          type="info"
          round
          @click="addAndReturn"
        >
          确定
        </van-button>
        <van-button
          v-if="!formData.zjxxId"
          type="info"
          round
          plain
          @click="addAndReturn"
        >
          添加
        </van-button>
        <van-button
          v-if="!formData.zjxxId"
          type="info"
          round
          @click="addAndContinue"
        >
          确认并继续添加
        </van-button>
      </div>
  </div>
</template>

<script>
import MyTitle from "../../../components/common/myTitle";
import { mapGetters } from "vuex";
import validate from "@/utils/validator/validator";
import { saveXxbqData } from "../../../api/guarantee";
import { zjlxType } from "../../../filters/index";
import {
  czjmcRule,
  czjlyRule,
  dBqksrqRule,
  dBqjsrqRule,
  csxsmRule,
} from "@/utils/validator/rules";
import { getId } from "@/api/common";

export default {
  name: "addXwxx",
  components: {
    MyTitle,
  },
  data() {
    return {
      bqksrqCurrentDate: new Date(),
      bqjsrqCurrentDate: new Date(),
      checked: "1",
      checkRadioFlag: false,
      showBqksrq: false,
      showBqjsrq: false,
      formData: {
        zjxxId: null, // id
        nZjlx: 1,
        nZjlxTxt: "当事人陈述",
        // cZjsm:'',
        // cZjmc: '',
        nyjwj: "1",
        // nYjwjTxt: '是',
        // cZjly: ''

        nzjlx: 1,
        czjmc: null,
        // nYjwj: 1,
        czjly: null,
        cSm: null,
        dBqksrq: "",
        dBqjsrq: "",
        cid: null, // 证据信息主键
        cxbid: null, // 续行保全id
        cbqid: null, // 证据保全id
      },
      myRules: [],
      showZjbqsx: false,
      codeZjList: [
        { text: "当事人陈述", value: "1" },
        { text: "被告人陈述", value: "2" },
        { text: "犯罪嫌疑人、被告人供述和辩解", value: "3" },
        { text: "书证", value: "4" },
        { text: "物证", value: "5" },
        { text: "视听资料", value: "6" },
        { text: "电子数据", value: "7" },
        { text: "证人证言", value: "8" },
        { text: "鉴定意见", value: "9" },
        { text: "勘验、检查、辨认、侦查实验等笔录", value: "10" },
        { text: "其他", value: "255" },
      ],
    };
  },
  computed: {
    ...mapGetters(["xxbqzjxxData", "xxbqdbxxData"]),
  },
  methods: {
    onBqrqConfirm: function (item) {
      if (item === "1") {
        this.formData.dBqksrq = this.timeFormat(this.bqksrqCurrentDate);
        this.showBqksrq = false;
      }
      if (item === "2") {
        this.formData.dBqjsrq = this.timeFormat(this.bqjsrqCurrentDate);
        this.showBqjsrq = false;
      }
    },
    onBqrqcancelFn(item) {
      if (item === "1") {
        this.showBqksrq = false;
      }
      if (item === "2") {
        this.showBqjsrq = false;
      }
    },
    timeFormat(time) {
      // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return year + "-" + month + "-" + day;
    },
    onSxsmConfirm: function (item) {
      this.formData.nzjlx = item.value;
      this.formData.nZjlxTxt = item.text;
      this.showZjbqsx = false;
      console.log("--onSxsmConfirm 111", item);
      console.log("--onSxsmConfirm 222", this.formData);
    },
    // initForm() {
    //     let obj = {
    //         nZjlx: 1,
    //         cZjmc: null,
    //         // nYjwj: 1,
    //         cZjly: null,
    //         cSm: null,
    //         dBqksrq:'',
    //         dBqjsrq:'',
    //         cid: null, // 证据信息主键
    //         cjbid: null, // 解除保全id
    //         cbqid: null, // 证据保全id
    //     }
    //     for (let key in obj) {
    //         this.formData[key] = obj[key]
    //     }
    // },
    //组装提交数据
    params() {
      let xbJbxx = [];
      let xxbqzjxx = [];
      let xxDbxxs = [];
      xxDbxxs = this.xxbqdbxxData;
      console.log(this.xxbqzjxxData);
      if (this.xxbqzjxxData.length > 0) {
        xxbqzjxx = this.xxbqzjxxData;
      }
      xxbqzjxx.push(this.formData);
      xbJbxx = JSON.parse(sessionStorage.getItem("xxbqjbxx"));
      return {
        dbJbxxs: xxDbxxs,
        xbJbxx: xbJbxx,
        xbCcxxs: [],
        xbZjxxs: xxbqzjxx,
        xbXwxxs: [],
      };
    },
    validateFormData() {
      // 校验规则
      let descriptor = {};
      descriptor.czjmc = czjmcRule;
      descriptor.czjly = czjlyRule;
      descriptor.dBqksrq = dBqksrqRule;
      descriptor.dBqjsrq = dBqjsrqRule;
      return validate(descriptor, this.formData);
    },
    async onSubmit(fn) {
      // debugger
      let params = await this.params();
      this.formData.cxbid = this.$route.query.cId;
      this.formData.cbqid = this.$route.query.bqid;
      var zjxxId = sessionStorage.getItem("bqZjxxId");
      if (zjxxId) {
        this.formData.cid = zjxxId;
      } else {
        this.formData.cid = await this.myId(0);
      }
      console.log("--数据提交 111", this.formData, params);
      this.validateFormData().then(() => {
        saveXxbqData(params)
          .then((res) => {
            console.log("--addXcxXw 123", res);
            if (res.code === 200) {
              this.$notify({ type: "success", message: "操作成功" });
            } else {
              this.$notify(res.message);
            }
            fn();
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    addAndReturn() {
      this.onSubmit(() => {
        this.$router.push({
          path: "/continuationPreservationNew",
          query: {
            bqid: this.$route.query.bqid,
            cId: this.$route.query.cId,
          },
        });
      });
    },
    addAndContinue() {
      this.onSubmit(() => {
        // debugger
        setTimeout(() => {
          window.location.reload();
        }, 500);
      });
    },
    initData() {
      var data = this.formData;
      this.formData.nzjlx = data.nzjlx;
      this.formData.nZjlxTxt = zjlxType(data.nzjlx);
      this.formData.czjmc = data.czjmc;
      this.formData.nyjwj = data.nyjwj.toString();
      this.formData.czjly = data.czjly;
      this.formData.cSm = data.cSm;
      this.formData.dBqksrq = data.dBqksrq;
      // this.formData.dbqjsrq = dateFormat(data.dbqjsrq, "yyyy-MM-dd");
      this.formData.dBqjsrq = data.dBqjsrq;
    },
    /**
     * 获取id
     * */
    myId(i) {
      return new Promise((resolve, reject) => {
        i++;
        if (i > 3) {
          this.$notify("系统错误，请重试!");
          reject();
        } else {
          getId()
            .then((res) => {
              resolve(res.data);
            })
            .catch(() => {
              return this.myId(i);
            });
        }
      });
    },
  },
  created() {
    // this.myRules = new Rules(this.formData)
    console.log("--created zjxx");
    var xxzjxxItem = sessionStorage.getItem("xxzjxxItem");
    // if(jcxwxxItem){
    //     this.formData = JSON.parse(jcxwxxItem);
    //     this.initData();
    // }
    var zjxxId = sessionStorage.getItem("bqZjxxId");
    if (xxzjxxItem) {
      this.formData = JSON.parse(xxzjxxItem);
      this.formData.zjxxId = zjxxId;
      this.initData();
    }
  },
  mounted() {
    this.timeFormat(new Date());
  },
  // 路由跳转之前保存当前滚动条的位置。
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem("xxzjxxItem");
    sessionStorage.removeItem("bqZjxxId");
    next();
  },
};
</script>

<style lang="less" scoped>
#fd-zjxx {
  width: 100%;
  height: 100%;
  overflow: hidden;

    .fd-textarea {
      height: auto;
    }
}
</style>
